import { styled, css, Card, Button } from '@mui/material';
import { theme } from 'assets/themes/zizzi';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import { Color } from 'models';

const iconDarkBGColor = theme.palette.primary.dark;
const iconLightBGColor = theme.palette.white;

interface CloseIconProps {
  iconcolor?: Color;
}

interface BackButtonProps {
  closetype?: 'back' | 'close' | 'none';
}

export const StyledCard = styled(Card)`
  border-radius: 0;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0;
`;

export const BackButton = styled(Button)<BackButtonProps>`
  min-width: 50px;
  padding: 0;
  position: absolute;
  z-index: 1;
  ${({ closetype }) =>
    closetype === 'close' &&
    css`
      right: 0%;
    `};
`;

export const ArrowIcon = styled(ArrowBackIcon)`
  color: ${theme.palette.white};
`;

export const StyledCloseIcon = styled(CloseIcon)<CloseIconProps>`
  color: ${iconLightBGColor};
  ${({ iconcolor }) =>
    iconcolor === 'dark' &&
    css`
      color: ${iconDarkBGColor};
    `};
`;
